import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import ModulVerziaItem from '../model/ModulVerziaItem';
import Verzia from '../model/Verzia';

const MAGNOLIA_KOMPONENTY = ['ZZ archív', 'ZZ generátor', 'ZZ service', 'Cms-service', 'IAM-KCLK', 'CWS'];

export const getVerzieSlovlexuZMagnolie = async (): Promise<ModulVerziaItem[]> => {
  try {
    const { data } = await cmsAxiosInstance.get('/verzia-slovlexu?limit=100');
    const riadkyNode = data.results.find((n: {
      '@name': string
    }) => n['@name'] === 'verzia-slovlexu-riadky');
    const riadky = Object.keys(riadkyNode)
      .filter((k) => /^\d+$/.test(k))
      .map((k) => riadkyNode[k]);
    return riadky
      .filter((r: { hodnotaStlpecPrvy: string }) => MAGNOLIA_KOMPONENTY.includes(r.hodnotaStlpecPrvy))
      .map((r: {
      hodnotaStlpecPrvy: string; hodnotaStlpecDruhy: string; hodnotaStlpecTreti: string;
      hodnotaStlpecStvrty?: string
    }) => ({
        nazov: r.hodnotaStlpecPrvy,
        verzia: r.hodnotaStlpecDruhy ?? '—',
        buildTime: r.hodnotaStlpecTreti ?? '—',
        deployTime: r.hodnotaStlpecStvrty || undefined,
        chyba: false,
      }));
  } catch {
    return MAGNOLIA_KOMPONENTY.map((nazov) => ({
      nazov, verzia: '—', buildTime: '—', chyba: true,
    }));
  }
};

export const getVerziaSlovlexu = async ():
    Promise<ClientResponse<Verzia>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/verzia-slovlexu?limit=100',
  );

  const verziaSlovlexuNode = data.results.find((node) => node['@name'] === 'verzia-slovlexu');
  const verziaSlovlexuRiadkyNode = data.results.find((node) => node['@name'] === 'verzia-slovlexu-riadky');

  const riadkyNodes = Object.keys(verziaSlovlexuRiadkyNode)
    .filter((key) => /^\d+$/.test(key))
    .map((key) => verziaSlovlexuRiadkyNode[key]);

  const mappedData = {
    popis: verziaSlovlexuNode[0].popis,
    nazovStlpecPrvy: verziaSlovlexuNode[0].nazovStlpecPrvy,
    nazovStlpecDruhy: verziaSlovlexuNode[0].nazovStlpecDruhy,
    nazovStlpecTreti: verziaSlovlexuNode[0].nazovStlpecTreti,
    nazovStlpecStvrty: verziaSlovlexuNode[0].nazovStlpecStvrty,
    riadky: riadkyNodes,
  };

  return {
    data: mappedData,
    responseCode: status,
  };
};
